var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"BnpTab"}},[_c('div',[_c('b-tabs',{attrs:{"active-nav-item-class":"font-weight-bold  text-info"}},_vm._l((_vm.tab),function(item,index){return _c('b-tab',{key:index,attrs:{"lazy":"","active":item.active,"title":item.header}},[_vm._t('content' + index)],2)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }